import React from "react";
const DraggableHOC = (Component) => {
  const Draggable = (props) => /* @__PURE__ */ React.createElement("div", { "data-drag-handle": true, draggable: true }, /* @__PURE__ */ React.createElement(Component, { ...props }));
  Draggable.displayName = "Draggable";
  return Draggable;
};
var draggable_HOC_default = DraggableHOC;
export {
  draggable_HOC_default as default
};
//# sourceMappingURL=draggable-HOC.js.map
